<template>
  <footer class="app-footer">
    <span><a href="http://www.wilshirecoin.com/">Metal Market</a> &copy; 2020 WC3 LP</span>
    <span class="ml-auto">Powered by <a href="https://www.skyhoundinternet.com/">Skyhound Internet</a></span>
  </footer>
</template>
<script>
export default {
  name: 'footer'
}
</script>



// WEBPACK FOOTER //
// Footer.vue?5efd6167